<template>
    <div class="loginPubilc">
        <l-header/>
        <router-view/>
        <l-footer/>
    </div>
</template>
<script>
import lHeader from '../../components/login/header.vue'
import lFooter from '../../components/login/footer.vue'
export default {
    components: {
        lHeader,
        lFooter
    }
}
</script>
<style scoped></style>